import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';

import { H1, P1 } from '@/lib/shared/components/Typography';

import { clsx } from 'clsx';
import { useTranslation } from 'next-i18next';

import styles from './CompanyValues.module.scss';
import { CompanyValuesCard } from './tabs';

const tabNames = [
  'care',
  'sustainability',
  'transparency',
  'professionalism',
  'synergy',
];

export const CompanyValues = () => {
  const { t } = useTranslation('index', { keyPrefix: 'about' });

  return (
    <div className={styles.values}>
      <div className={styles.container}>
        <H1 as={'h2'} className={styles.values_title}>
          {t('companyValues')}
        </H1>
        <Tabs className={styles.panel}>
          <TabList className={clsx(styles.tabs, styles.tab__list)}>
            {tabNames.map((name) => (
              <Tab className={styles.tab__light} key={name}>
                <P1>{t(name)}</P1>
              </Tab>
            ))}
          </TabList>
          <TabPanel>
            <CompanyValuesCard
              title={t('careAboutTitle')}
              prediction={t('careAboutText')}
            />
          </TabPanel>
          <TabPanel>
            <CompanyValuesCard
              title={t('sustainabilityTitle')}
              prediction={t('sustainabilityText')}
            />
          </TabPanel>
          <TabPanel>
            <CompanyValuesCard
              title={t('transparencyTitle')}
              prediction={t('transparencyText')}
            />
          </TabPanel>
          <TabPanel>
            <CompanyValuesCard
              title={t('professionalismTitle')}
              prediction={t('professionalismText')}
            />
          </TabPanel>
          <TabPanel>
            <CompanyValuesCard
              title={t('synergyTitle')}
              prediction={t('synergyText')}
            />
          </TabPanel>
        </Tabs>
      </div>
    </div>
  );
};
